module.exports = __webpack_public_path__ + "img/cbb.96db35a3.svg";